import type { JSX } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { useMyIntl } from 'my-intl';
import { PageNotFound, type PageNotFoundLangs } from 'page-not-found';
import 'page-not-found/page-not-found.css';

import About from './components/about';
import BSIC from './components/bsic';
import Camps from './components/camps';
import Contacts from './components/contacts';
import ContactDetails from './components/contact-details';
import Footer from './components/footer';
import Header from './components/header';
import Team from './components/team';
import Title from './components/title';
import ScrollTopButton from './components/scroll-top-button';

function App() {
  const { lang } = useMyIntl();

  const renderApp = (): JSX.Element => {
    return (
      <>
        <Header />
        <Title />
        <ContactDetails />
        <About />
        <BSIC />
        <Camps />
        <Team />
        <Contacts />
        <Footer />
        <ScrollTopButton />
      </>
    );
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={renderApp()} />
        <Route path="/#" element={renderApp()} />
        <Route path="/*index.html" element={renderApp()} />
        <Route path="/*index.htm" element={renderApp()} />
        <Route path="*" element={<PageNotFound lang={lang as PageNotFoundLangs} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
